import { defineModule, defineRoute } from "../../shared/define-module"
import type {
  GetTrendingFeedsRequest,
  GetTrendingFeedsResponse,
} from "./types"

/**
 * Trending module for discovering trending feeds
 */
export const trendingModule = defineModule({
  name: "trending",
  prefix: "/trending",
  routes: {
    // Get trending feeds with analytics
    getFeeds: defineRoute<GetTrendingFeedsRequest, GetTrendingFeedsResponse>(
      "GET",
      "/feeds",
    ),
  },
})

// Export the API type
export type TrendingAPI = typeof trendingModule.api

// Re-export types for external consumption
export type * from "./types"
